import { useRef, useState, useEffect } from "react";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DeleteIcon from '@mui/icons-material/Delete';

interface ImageUploadPreviewProps {
  //token: string;
  image: File | string | null;
  onChange: (file: File | null) => void;
  fast?: boolean
}

export default function ImageUploadPreview({ image, onChange, fast }: ImageUploadPreviewProps) {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [previewImage, setPreviewImage] = useState<string | null>(null);

  useEffect(() => {
    if (!image) {
      setPreviewImage(null);
      return;
    }

    if (typeof image === "object") {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result as string);
      };
      reader.readAsDataURL(image);
    }
    if (typeof image === "string") {
//      const fetchFile = async (url: string) => {
//        try {
//          const headers = new Headers();
//          //if (token) {
//          //    headers.set('Authorization', `Token ${token}`);
//          //}
//          headers.set('Accept', 'application/json');
//          const requestInit: RequestInit = {
//            method: 'GET',
//            headers: headers,
//            credentials: 'include',
//          }
//          const response = await fetch(url, requestInit);
//          const blob = await response.blob();
//          const filetype = blob.type
//          const file = new File([blob], 'file.' + filetype.split("/")[1], { type: filetype });
//          onChange(file);
//          setPreviewImage(url);
//        } catch (error) {
//          console.error('Errore durante il caricamento del file:', error);
//        }
//      };
//      fetchFile(image);
      setPreviewImage(image);
    }
  }, [image]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      onChange(file);
    }
  };

  return (<>
    <>
      {image ? (
        <div className="row align-items-center">
          <div className="col-8">
            {previewImage && (
              <img
                src={previewImage}
                alt="Preview"
                style={{ maxWidth: '100%', maxHeight: "200px", marginBottom: "1rem" }}
              />
            )}
          </div>
          <div className="col text-end">
            <button
              className="btn flex gap-2 mb-4 btn-light"
              style={{ backgroundColor: "#e7e7e7", color: "black" }}
              onClick={() => onChange(null)}
            >
              <DeleteIcon fontSize="small" /> Elimina
            </button>
          </div>

          <input
            type="file"
            accept="image/*"
            className="d-none"
            ref={fileInputRef}
            onChange={handleFileChange}
          />
        </div>
      ) : (
        <>
          <button
            className="btn flex gap-2 mb-4 btn-light"
            style={{ backgroundColor: "#e7e7e7", color: "black" }}
            onClick={() => fileInputRef.current?.click()}
          >
            <FileUploadIcon /> Carica file
          </button>
          <input
            type="file"
            accept="image/*"
            className="d-none"
            ref={fileInputRef}
            onChange={handleFileChange}
          />
        </>
      )}
    </>
  </>
  );
}
